export default __webpack_public_path__ + "assets/images/f6c2590ad8aacbe080e82f10236c0ff4-rejected_icon.svg";